<template>
  <AiSummary
    :response="cachedData || aiSummaryDetail || ''"
    :is-initial-loading="!cachedData && isInitialLoading"
    :is-error="isError"
    :question-list="TRANSACTION_AI_QUESTION_LIST"
    v-model:selected-question-type="questionType"
    :show-typing-animation="showTypingAnimation"
  />
</template>

<script setup lang="ts">
import { useQueryClient } from '@tanstack/vue-query'

import { aiSummaryService } from '~/api/service/ai-summary.service'
import { aiSummaryKey } from '~/api/service/query-keys.const'
import { useFetchTransactionDetail } from '~/api/service/transaction/[txnHash]/index.service'
import AiSummary from '~/components/ai-summary/AiSummary.vue'
import { TRANSACTION_AI_QUESTION_LIST } from '~/constants/ai-summary.constants'
import { aiQuestionType, aiSummaryDataType, IAiSummaryRequestParam } from '~/types/ai-summary.type'
import { getRouteParam } from '~/utils/route.util'

const queryClient = useQueryClient()

const txnHash = getRouteParam('txnHash')
const { data: transactionDetail } = useFetchTransactionDetail(txnHash)

const showTypingAnimation = ref(true)

const questionType = ref<aiQuestionType>(aiQuestionType.SUMMARY)

const param = computed((): IAiSummaryRequestParam => {
  return {
    question: questionType.value,
    dataType: aiSummaryDataType.TRANSACTION,
    requestBody: transactionDetail.value as Record<string, unknown>
  }
})

const { data: aiSummaryDetail, isError, isInitialLoading } = aiSummaryService.useGetAiSummary(param, transactionDetail)

const cachedData = computed(() => {
  return queryClient.getQueryState([ ...aiSummaryKey, param.value, transactionDetail.value ])?.data
})

watch(() => cachedData.value, () => {
  showTypingAnimation.value = !cachedData.value
}, { immediate: true })
</script>

<style scoped lang="scss">

</style>